<div>{{'history.event.node-labels-changed'|translate}}</div>
@for (label of labels; track label) {
  <div>
    <small>&#x2022; {{'history.event.node-labels-changed.detail'|translate:labelTranslate(label)}}</small>
  </div>
}
